<template>
    <footer class="py-5 text-center">
        <small>&copy; 2019 DTM Cafe</small>
    </footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>
</style>
